export function translate(key) {
    if (typeof window.sampleOrderTranslations != "undefined" && window.sampleOrderTranslations[key]) {
        return window.sampleOrderTranslations[key];
    } else if (typeof window.translations != "undefined" && window.translations[key]) {
        return window.translations[key];
    } else {
        return key;
    }
}